import React from "react";

const SvgComponent = ({ ...props }) => {
  const { iconSize, iconColor, className } = props;
  return (
    <svg stroke={iconColor || 'currentColor'} fill="none" strokeWidth="0"  viewBox="0 0 24 24" height={iconSize || '1em'} width={iconSize || '1em'} xmlns="http://www.w3.org/2000/svg"  className={className}>
      <path d="M20.56,3.34a1,1,0,0,0-1-.08l-17,8a1,1,0,0,0-.57.92,1,1,0,0,0,.6.9L8,15.45v6.72L13.84,18l4.76,2.08a.93.93,0,0,0,.4.09,1,1,0,0,0,.52-.15,1,1,0,0,0,.48-.79l1-15A1,1,0,0,0,20.56,3.34ZM18.1,17.68l-5.27-2.31L16,9.17,8.35,13.42,5.42,12.13,18.89,5.79Z"></path>
    </svg>
  );
};

export default SvgComponent;
